import { render, staticRenderFns } from "./ProductServiceDiscuss.vue?vue&type=template&id=08b5df72&scoped=true&"
import script from "./ProductServiceDiscuss.vue?vue&type=script&lang=js&"
export * from "./ProductServiceDiscuss.vue?vue&type=script&lang=js&"
import style0 from "./ProductServiceDiscuss.vue?vue&type=style&index=0&id=08b5df72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5df72",
  null
  
)

export default component.exports